import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  altText: {
    id: 'ora-grading.InfoPopover.alt-text',
    defaultMessage: 'Display more info',
    description: 'Info popover trigger element alt-text',
  },
});

export default messages;
